import 'bootstrap/dist/css/bootstrap.css';
import './components/styles/designTokens.css';

import React from 'react';
import ReactDOM from 'react-dom';
import './i18n';
import $ from 'jquery';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

window.jQuery = $;
require('bootstrap');

ReactDOM.render(
  <BrowserRouter basename="/">
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);
